import { ReactComponent as collectDeliveryPackage } from "@styles/svgs/package-1.svg";
import { ReactComponent as searchDeliveryPackage } from "@styles/svgs/package-2.svg";
import { ReactComponent as returnDeliveryPackage } from "@styles/svgs/package-3.svg";
import { ReactComponent as addDeliveryPackage } from "@styles/svgs/package-4.svg";
import { ReactComponent as addDelegatePackage } from "@styles/svgs/create-delegate-package_2.svg";
import { ReactComponent as addHome } from "@styles/svgs/add-home.svg";
import { ReactComponent as addVisitor } from "@styles/svgs/add-visitor.svg";
import { ReactComponent as collectDelegatePackage } from "@styles/svgs/collect-delegate-package_4.svg";
import { ReactComponent as news } from "@styles/svgs/news.svg";
import { ReactComponent as notification } from "@styles/svgs/notification.svg";
import { ReactComponent as managementFee } from "@styles/svgs/management-fee-1.svg";

// 首頁一塊一塊的功能
const featureList = [
  {
    key: "CreateConstructionDeliveryPackageByProperty",
    lable: "登記包裹",
    icon: addDeliveryPackage,
    isEditable: false
  },
  {
    key: "ChangeConstructionDeliveryPackageToCollectedByProperty",
    lable: "領取包裹",
    icon: collectDeliveryPackage,
    isEditable: false
  },
  {
    key: "ChangeConstructionDeliveryPackageToWaitReturnByProperty",
    lable: "退貨包裹",
    icon: returnDeliveryPackage,
    isEditable: false
  },
  {
    key: "ConstructionDeliveryPackageManager",
    lable: "包裹紀錄",
    icon: searchDeliveryPackage,
    isEditable: false
  },
  {
    key: "CreateConstructionVisitRecordByProperty",
    lable: "登記訪客",
    icon: addVisitor,
    isEditable: false
  },
  {
    key: "CreateConstructionDelegatePackageByProperty",
    lable: "寄放物品",
    icon: addDelegatePackage,
    isEditable: false
  },
  {
    key: "ChangeConstructionDelegatePackageToCollectedByProperty",
    lable: "領取物品",
    icon: collectDelegatePackage,
    isEditable: false
  },
  {
    key: "ConstructionNewsManager",
    lable: "社區公告",
    icon: news,
    isEditable: false
  },
  {
    key: "ViewJoinHouseholdUserByProperty",
    lable: "開通住戶",
    icon: addHome,
    isEditable: false
  },
  {
    key: "ConstructionNotificationManager",
    lable: "推播通知",
    icon: notification,
    isEditable: false
  },
  {
    key: "ConstructionManagementFeeManager",
    lable: "管理費",
    icon: managementFee,
    isEditable: false
  }
];

export const homeCodeList = {
  featureList
};
